export const SPECS = {
  ShouldAddSpecificItemDiscountsForCashierValidation: 'specs.stores.ShouldAddSpecificItemDiscountsForCashierValidation',
  SupportDelayedCaptureOnCheckoutAndExpressButtons: 'specs.stores.SupportDelayedCaptureOnCheckoutAndExpressButtons'
};
//# sourceMappingURL=SPECS.js.map